import { render, staticRenderFns } from "./RewardModal.vue?vue&type=template&id=20fb4e60&scoped=true&"
import script from "./RewardModal.vue?vue&type=script&lang=js&"
export * from "./RewardModal.vue?vue&type=script&lang=js&"
import style0 from "./RewardModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RewardModal.vue?vue&type=style&index=1&id=20fb4e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb4e60",
  null
  
)

export default component.exports